import styled from "styled-components";

export const AlgorithmIcon = styled.img`
  flex-shrink: 0;
  width: 38px;
  height: 34px;
  margin-top: ${({ theme }) => theme.space.sm};
  margin-bottom: ${({ theme }) => theme.space.sm};
  margin-right: 0.75rem;
`;

export const AlgorithmTitleText = styled.span`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  color: ${({ theme }) => theme.colors.secondary.base};
`;

export const AlgorithmPDFText = styled.span`
  padding-left: ${({ theme }) => theme.space.xs};
`;
